<template>
   <div class="container">
      <div class="center">
         <div class="nav-bar">
            <p>
               <span class="parent-link"  @click="navToHome()" >Admin</span>
               <span> >> </span>
               <span> {{title}} </span>
            </p>
         </div>
         <div  class="nav-select" style="width:100%;margin-top: 15px;">
            <el-input placeholder="请在此输入正确的账号" v-model="input3" class="input-with-select">
               <el-button slot="append" @click="search">搜索</el-button>
            </el-input>
         </div>
         <div v-if="hasAccount">
            <p style="margin-top:15px;">{{formLabelAlign.accounts}}</p>
            <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="margin-top:20px;">
               <p class="span1">Type</p>
               <p class="span2">{{alignType}}</p>
               <el-form-item label="Country/region" style="margin-top:20px;">
                  <el-select v-model="formLabelAlign.region" placeholder="请选择国家地区" class="from-item">
                     <el-option
                        v-for="item in countries"
                        :key="item.index"
                        :label="item.name"
                        :value="item.id"
                     >
                     </el-option>
                  </el-select>
               </el-form-item>
               <el-form-item label="Name">
                  <el-input v-model="formLabelAlign.name" class="from-item"></el-input>
               </el-form-item>
               <el-form-item label="Organization">
                  <el-input v-model="formLabelAlign.orz" class="from-item"></el-input>
               </el-form-item>
               <el-form-item label="Email">
                  <el-input v-model="formLabelAlign.email" class="from-item"></el-input>
               </el-form-item>
               <el-form-item label="Mobile">
                  <el-input v-model="formLabelAlign.mobile" class="from-item"></el-input>
               </el-form-item>
               <el-form-item label="Password">
                  <el-input v-model="formLabelAlign.password" class="from-item"></el-input>
               </el-form-item>
               <el-form-item>
                  <el-button type="danger" @click="del" round='true'>删除账号</el-button>
                  <el-button type="primary" @click="refresh" round='true'>更新账号</el-button>
               </el-form-item>
            </el-form>
         </div>
      </div>
      <el-dialog
         :visible.sync="dialogVisible"
         width="30%"
         center="true">
         <span >搜索失败，无此账号信息，请检查确认！</span>
         <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
         </span>
      </el-dialog>
      <el-dialog
         class="dialog"
         title="是否删除账号？"
         :visible.sync="centerDialogVisible"
         :before-close="handleDialogClose"
         width="10%"
         center>
         <el-input placeholder="验证码" v-model="input4" style="width:300px;">
            <el-button slot="append" @click="delTest" style="width:120px;" :disabled="disabled">{{btnText}}</el-button>
         </el-input>
         <p v-show="shoWFalse" style="color:red;">验证码对比失败，请重试</p>
         <span slot="footer" class="dialog-footer">
            <el-button @click="cancelDel">取 消</el-button>
            <el-button type="primary" @click="determineDel">确 定</el-button>
         </span>
      </el-dialog>
      <el-dialog
         class="dialog"
         title="是否更新账号信息？"
         :visible.sync="RefreshDialogVisible"
         width="10%"
         :before-close="handleDialogClose"
         center>
         <el-input placeholder="验证码" v-model="input5" style="width:300px;">
            <el-button slot="append" @click="refreshTest" style="width:120px;" :disabled="disabled">{{btnText}}</el-button>
         </el-input>
         <p v-show="shoWFalse" style="color:red;">验证码对比失败，请重试</p>
         <span slot="footer" class="dialog-footer">
            <el-button @click="cancelRefresh">取 消</el-button>
            <el-button type="primary" @click="determineRefresh">确 定</el-button>
         </span>
      </el-dialog>
   </div>
</template>

<script>
export default {
   data() {
      return {
         formLabelAlign: {
            accounts:'123',
            region:'',
            name:'',
            orz:'',
            email: '',
            mobile: '',
            password: '',
            type:''
         },
         shoWFalse:false,
         input3:'',
         input4:'',
         input5:'',
         token:'',
         title:'Accounts',
         disabled: false,
         totalCount:0,
         labelPosition: 'left',
         hasAccount:false,
         dialogVisible:false,
         centerDialogVisible:false,
         RefreshDialogVisible:false,
         countries:[
            {id: 'CN',name: 'CN'},
            {id: 'GB',name: 'GB'},
            {id: 'FR',name: 'FR'},
            {id: 'DD',name: 'DD'},
            {id: 'SE',name: 'SE'},
            {id: 'AU',name: 'AU'},
            {id: 'HKF',name: 'HKF'},
            {id: 'HU',name: 'HU'},
            {id: 'IT',name: 'IT'},
            {id: 'NL',name: 'NL'},
            {id: 'Nor',name: 'Nor'},
            {id: 'PT',name: 'PT'},
            {id: 'ES',name: 'ES'},
            {id: 'TR',name: 'TR'},
            {id: 'AE',name: 'AE'},
            {id: 'Ro',name: 'Ro'},
            {id: 'CZ',name: 'CZ'},
            {id: 'SK',name: 'SK'},
            {id: 'LT',name: 'LT'},
            {id: 'PL',name: 'PL'},
            {id: 'DK',name: 'DK'},
            {id: 'FI',name: 'FI'}
         ]
      }
   },
   methods:{
      //删除账号点击事件
      del () {
         this.centerDialogVisible =true
      },

      // 删除账号提交前获取验证码
      delTest() {
         this.disabled=true
         this.totalCount=60
         this.interval=setInterval(()=>{
            this.totalCount--
            if(this.totalCount === 0){
               clearInterval(this.interval)
               this.disabled=false
            }
         },1000);
         let val ={
         'purpose':'user_admin',
         'data': {
            'action':'delete_user',
            'username': this.input3
            }
         }
         this.$http.post('/api/v2.1/seccode/send',val).then(res => {
            if(res.status ===200){
               if(res.body.error === 0) {
                  this.token =res.body.token
               }else {
                  this.token =''
               }
            }
         })
      },

      // 删除账号取消事件
      cancelDel() {
         this.centerDialogVisible =false
         this.input4 =''
         this.shoWFalse =false
      },

      //删除账号确定事件
      determineDel() {
         this.delAccounts()
      },

      //发送删除账号请求
      delAccounts () {
         let val = {
             username:this.input3,
             seccode:this.input4,
             token:this.token
         }
         this.$http.post('/api/v2.1/admin/user/delete_user',val).then(res => {
            if(res.status ===200){
               if(res.body.error === 0) {
                  this.$message({
                     type: 'success',
                     message: '删除成功!'
                  });
                  this.centerDialogVisible =false
                  this.input4 =''
                  this.hasAccount =false
               }else if(res.body.error === 26){
                  this.shoWFalse =true
               }else {
                     this.$message({
                     type: 'info',
                     message: '删除失败'
                  });
                  this.centerDialogVisible =false
                  this.input4 =''
               }
            }else {
               this.$message({
                  type: 'info',
                  message: '删除失败'
               });
               this.centerDialogVisible =false
               this.input4 =''
            }
         })
      },

      //更新账号点击事件
      refresh() {
         this.RefreshDialogVisible =true
      },

      // 更新账号获取验证码
      refreshTest () {
         this.disabled=true
         this.totalCount=60
         this.interval=setInterval(()=>{
            this.totalCount--
            if(this.totalCount === 0){
               clearInterval(this.interval)
               this.disabled=false
            }
         },1000);
         let val ={
         'purpose':'user_admin',
         'data': {
            'action':'update_info',
            'username': this.input3
            }
         }
         this.$http.post('/api/v2.1/seccode/send',val).then(res => {
            if(res.status ===200){
               if(res.body.error === 0) {
                  this.token =res.body.token
               }else {
                  this.token =''
               }
            }
         })
      },

      // 更新账号取消事件
      cancelRefresh() {
         this.RefreshDialogVisible =false
          this.input5 =''
          this.shoWFalse =false
      },

      //更新账号确定事件
      determineRefresh() {
         this.refreshUser()
      },

      // 更新账号请求
       refreshUser () {
         let val
         if(this.formLabelAlign.password === ''){
            val ={
               username:this.input3,
               info:{
                  "country":this.formLabelAlign.region, 
                  "email": this.formLabelAlign.email,  
                  "mobile": this.formLabelAlign.mobile, 
                  "serve_for": this.formLabelAlign.orz,  
                  "username": this.formLabelAlign.name
               },
               seccode:this.input5,
               token:this.token
            }
         }else{
             val ={
               username:this.input3,
               info:{
                  "country":this.formLabelAlign.region, 
                  "email": this.formLabelAlign.email,  
                  "mobile": this.formLabelAlign.mobile, 
                  "serve_for": this.formLabelAlign.orz,  
                  "username": this.formLabelAlign.name,
                  "password": this.formLabelAlign.password
               },
               seccode:this.input5,
               token:this.token
            }
         }
         
         this.$http.post('/api/v2.1/admin/user/update_info',val).then(res => {
            if(res.status ===200){
               if(res.body.error === 0){
                     this.$message({
                     type: 'success',
                     message: '更新成功!'
                  });
                  this.RefreshDialogVisible =false
                  this.input5 =''
               }else if(res.body.error === 26){
                  this.shoWFalse =true
               }else {
                     this.$message({
                     type: 'info',
                     message: '删除失败'
                  });
                  this.RefreshDialogVisible =false
                  this.input5 =''
               }
            }else {
                     this.$message({
                     type: 'info',
                     message: '删除失败'
                  });
                  this.RefreshDialogVisible =false
                  this.input5 =''
               }
         })
      },

      //右上角x事件
      handleDialogClose () {
         this.input5 =''
         this.input4 =''
         this.centerDialogVisible =false
         this.RefreshDialogVisible =false
         this.shoWFalse =false
      },
      navToHome() {
         this.$router.push('/accountsadmin_home')
      },

      search () {
         if(this.input3===''){
            this.$message({
            type: 'info',
            message: '请输入正确的账号'
          });
          return
         }
         let val ={
            username:this.input3,
         }
         this.$http.post('/api/v2.1/admin/user/get_user',val).then(res => {
            if(res.status ===200){
               if(res.body.error === 0&&res.body.info.length!==0){
                  this.formLabelAlign.name =res.body.info.realname
                  this.formLabelAlign.accounts =res.body.info.username
                  this.formLabelAlign.region = res.body.info.country,
                  this.formLabelAlign.orz= res.body.info.serve_for,
                  this.formLabelAlign.email = res.body.info.email,
                  this.formLabelAlign.mobile= res.body.info.mobile
                  this.formLabelAlign.type= res.body.info.user_type
                  this.hasAccount =true
               }else{
                  this.hasAccount =false
                  this.dialogVisible = true
               }
            }else{
               this.hasAccount =false
            }
         })
      }
   },
   computed: {
      alignType () {
         if(this.formLabelAlign.type ==='P'){
            return 'Patient'      
         }else if(this.formLabelAlign.type ==='M') {
            return 'Carer'
         }else if(this.formLabelAlign.type ==='D') {
            return 'HCP'
         }
      },
      btnText(){
         return this.totalCount !==0? `${this.totalCount}秒再次获取`: "获取验证码"
       }
   },
   created() {
    let that = this;
    document.onkeydown =function(e){
      e = window.event || e;
      if(that.$route.path==='/UserAdmin'&&(e.code==='Enter'||e.code==='enter'||e.code==='NumpadEnter')&&!e.isComposing){//验证在登录界面和按得键是回车键enter
        that.search();//搜索函数
        }
      }
    }
}
</script>

<style scoped>
  .container {
    height:100%;
    background-color:#ffffff;
  }

  .container .center {
    width: 75%;
    margin: 0 auto;
  }

  .container .center .no-data {
    padding-top: 5%;
  }
  .container .center .nav-bar {
    padding-top: 50px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
  }
  .container .center .nav-bar span{
    cursor: pointer;
  }
  .container .center .nav-select {
   display: flex;
   justify-content: flex-end;
    border-bottom: 1px solid #ccc;
    padding-bottom: 15px;
  }
  .operate{
    display: flex;
    justify-content: space-between;
  }
  .input-with-select {
     width: 500px;
  }
  .from-item {
     width: 300px;
  }
  .span1 {
     display: inline-block;
     width: 120px;
     font-size: 20px;
     text-align: left;
     padding-right: 12px;
  }
  .span2 {
   display: inline-block;
   font-size: 20px;
  }
  .dialog {
     width: 800px;
     margin-left: 50%;
     margin-top: 300px;
     left: -400px;
  }
</style>


// WEBPACK FOOTER //
// UserAdmin.vue?e16fc35e